import { ENV } from "../../config/env";
import { CrmDashboard } from "./CrmDashboard";
import { PlaceholderDashboard } from "./PlaceholderDashboard";

/**
 * Dashboard component that renders based on VITE_DASHBOARD_TYPE env variable.
 *
 * Available dashboard types:
 * - "placeholder" (default): Shows a generic placeholder dashboard
 * - "crm": Shows the CRM-specific dashboard with leads, opportunities, etc.
 *
 * Set VITE_DASHBOARD_TYPE in .env.local to switch between dashboards.
 */
export const Dashboard: React.FC = () => {
  const dashboardType = ENV.DASHBOARD_TYPE;

  switch (dashboardType) {
    case "crm":
      return <CrmDashboard />;
    case "placeholder":
    default:
      return <PlaceholderDashboard />;
  }
};
